export default "__VITE_ASSET__C1J4v4Pd__"